
import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
@Injectable()
export class AppConstants {
  endPoints: any = {};
  constructor(
    private http: HttpClient,
     private keycloakService: KeycloakService,
     private authService : AuthService,
     private router : Router
     ) { }
  endApIPoints() {
    this.http.get('./assets/appConfig/apiservices.json').subscribe((res: any) => {
      this.endPoints = res['constants']
      return this.endPoints;
    });
  }

  userDetails  :any = {};
  async load() {
    const keycloak: any = await this.getKeycloakConfig();
    return new Promise(async (resolve, reject) => {
      try {

        await this.keycloakService.init({
          config: keycloak,
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe : false
          },
          bearerExcludedUrls: []
        });
        const lang = await this.getProfileInfo();
        const user =  await this.keycloakService.loadUserProfile();
        this.userDetails = user;
        resolve('done');
      } catch (error) {
        reject(error);
      }
    });

  }

  getProfileInfo() {
    return new Promise((resolve, reject) => {
      let url = this.endPoints.tenantEndPoint + 'webcomponent/user-profile';
      return this.http.get(url, {}).subscribe((res:any)=>{
        const preferredLanguage = res && res.preferredLanguageCode ? res.preferredLanguageCode : 'en';
        this.setPreferredLanguage(preferredLanguage);
        resolve(res)
      }, err=>{
        this.setPreferredLanguage('en');
        resolve(null)
      }) 
    });
}

setPreferredLanguage(preferredLanguage){
        const userSettings = { preferredLanguageCode: preferredLanguage};
        localStorage.setItem("userSettingsJson", JSON.stringify(userSettings));
}


  getKeycloakConfig() {
    return new Promise((resolve, reject) => {
      this.http.get('./assets/appConfig/keycloak.json').subscribe((res: any) => {
        resolve(res);
      });
    });
  }

  tenantId : any = {}
  async getTenantId(){    
    return new Promise(async (resolve, reject) => {    
      try {
        if (await this.keycloakService.isLoggedIn()) {
          const token = await this.keycloakService.getToken();      
          const tenant = await this.parseKeycloakToken(token);
          this.tenantId = tenant.tenantId;
          resolve(tenant);                 
        }else{
          resolve('done');      
        }
      } catch (error) {
        reject(error);
      }
    })
  }
  
  parseKeycloakToken (token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

tenantUserId: any = '';
async getTenantUserId() {
  return new Promise<void>(async (resolve, reject) => {
    try {
      if (await this.keycloakService.isLoggedIn()) {
        const token = await this.keycloakService.getToken();
        const tenant = await this.parseKeycloakToken(token);
        this.tenantUserId = tenant.tenantUserId;
        resolve(tenant);
      } else {
        resolve();
      }
    } catch (error) {
      reject(error);
    }
  });
}

isRoleAvailable : boolean = false;
  async checkTenantUserId()
  {
    await this.keycloakService.updateToken(-1)
    await this.getTenantUserId();
    this.isRoleAvailable  = await this.authService.checkRoleExist('trutesta-ulc')
    let tenantUserId = this.tenantUserId && this.tenantUserId.length ? this.tenantUserId : null
    if(!tenantUserId || !this.isRoleAvailable){
    this.router.navigate(['/authorized']);
    this.authService.roleAccessSubscription.next(false)
    }
    else if (tenantUserId && this.isRoleAvailable){
      this.authService.roleAccessSubscription.next(true);
    this.router.navigate(['/customers']);
    }
  }

  setupLoader = new Subject<any>();
  async checkAuth() {
    return new Promise((resolve) => {
      let count = 0;
      let checkRoleTenantInterval = setInterval(() => {
        return new Promise(async (resolve, reject) => {
          const token = await this.keycloakService.updateToken(-1);
          this.checkTenantUserId();
          count = count + 1;
          if (count == 15 || (this.tenantUserId && this.isRoleAvailable)) {
            this.setupLoader.next(false);
            clearInterval(checkRoleTenantInterval);
          }
        });
      }, 1000);
    });
  }

}